module.exports = __webpack_public_path__ + "img/2.d79c1d23.png";